export const RegisterIcon = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      fill="#2E7D32"
    />
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      stroke="#E5E7EB"
    />
    <g clipPath="url(#clip0_48_501)">
      <path
        d="M21.5 26C21.5 24.4087 22.1321 22.8826 23.2574 21.7574C24.3826 20.6321 25.9087 20 27.5 20C29.0913 20 30.6174 20.6321 31.7426 21.7574C32.8679 22.8826 33.5 24.4087 33.5 26C33.5 27.5913 32.8679 29.1174 31.7426 30.2426C30.6174 31.3679 29.0913 32 27.5 32C25.9087 32 24.3826 31.3679 23.2574 30.2426C22.1321 29.1174 21.5 27.5913 21.5 26ZM17 42.6078C17 37.9906 20.7406 34.25 25.3578 34.25H29.6422C34.2594 34.25 38 37.9906 38 42.6078C38 43.3766 37.3766 44 36.6078 44H18.3922C17.6234 44 17 43.3766 17 42.6078ZM40.625 34.625V31.625H37.625C37.0016 31.625 36.5 31.1234 36.5 30.5C36.5 29.8766 37.0016 29.375 37.625 29.375H40.625V26.375C40.625 25.7516 41.1266 25.25 41.75 25.25C42.3734 25.25 42.875 25.7516 42.875 26.375V29.375H45.875C46.4984 29.375 47 29.8766 47 30.5C47 31.1234 46.4984 31.625 45.875 31.625H42.875V34.625C42.875 35.2484 42.3734 35.75 41.75 35.75C41.1266 35.75 40.625 35.2484 40.625 34.625Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_48_501">
        <path d="M17 20H47V44H17V20Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default RegisterIcon;
